import { BehaviorSubject } from 'rxjs';

import { BaseWorkerLifeCycleEnum } from './base-worker-lifecycle.enum';
import { WorkerInterface } from './worker.interface';

export abstract class AbstractWorker implements WorkerInterface {

	public lifeCycleState: BehaviorSubject<BaseWorkerLifeCycleEnum | string>;
	public workerInterface: WorkerInterface;

	constructor() {
		this.lifeCycleState = new BehaviorSubject(BaseWorkerLifeCycleEnum.INIT);
	}

	public setLifeCycleState(state: BaseWorkerLifeCycleEnum | string): void {
		this.lifeCycleState.next(state);
	}

	public handle(queryParams: any): void { }
}
